import { useEffect, useState } from 'react';
import WebSocketContext from '@/context/WebSocketContext.jsx';
import { getMessageEmitter, destroyMessageEmitter } from '@/utils/socket.js';
import { getToken } from '@/utils/cookie';
import routes from '@/routes';
const WebSocketProvider = ({ children }) => {
  const [messageEmitter, setMessageEmitter] = useState(null);
  const [wsConnect, setWsConnect] = useState(0);
  const [token, setToken] = useState(null);
  useEffect(() => {
    if (!token) {
      destroyMessageEmitter();
      return;
    }
    let isMounted = true;

    const initMessageEmitter = async () => {
      try {
        const emitter = await getMessageEmitter();
        if (isMounted) {
          console.log(emitter, '=====emitteremitter');
          setMessageEmitter(emitter);
        }
      } catch (error) {
        console.error('Failed to initialize MessageEmitter:', error);
      }
    };
    if (getToken()) {
      initMessageEmitter();
    }
    console.log(getToken(), 'getToken()getToken()');

    return () => {
      isMounted = false;
      destroyMessageEmitter();
    };
  }, [token]);

  useEffect(() => {
    // 初始获取当前路由
    console.log('当前路由1:', window.location.pathname);
    handleTokenLogic();
    const handleRouteChange = () => {
      console.log('当前路由:', window.location.pathname);
      handleTokenLogic();
    };

    const unlisten = routes.subscribe(handleRouteChange);

    return () => {
      unlisten();
    };
  }, []);
  useEffect(() => {
    if (wsConnect > 0) {
      handleTokenLogic();
    }
  }, [wsConnect]);
  const handleTokenLogic = () => {
    if (!getToken()) {
      setToken('');
    } else {
      setToken(getToken());
    }
  };

  return (
    <WebSocketContext.Provider value={{ messageEmitter, setWsConnect }}>
      {children}
    </WebSocketContext.Provider>
  );
};

export default WebSocketProvider;
